export const WRITING_TYPES = [
    { id: 1, name: "Writing from scratch" },
    { id: 2, name: "Editing" },
    { id: 3, name: "AI Humanization" },
    { id: 4, name: "Rewriting" },
]

export const TYPE_OF_PAPERS = [
  { id: 1, name: "Analytical Essay" },
  { id: 2, name: "Annotated Bibliography" },
  { id: 3, name: "Application/Admission Essay" },
  { id: 4, name: "Argumentative Essay" },
  { id: 5, name: "Article Critique" },
  { id: 6, name: "Book Review" },
  { id: 7, name: "Business Plan" },
  { id: 8, name: "Case Study" },
  { id: 9, name: "Cause and Effect Essay" },
  { id: 10, name: "Compare and Contrast Essay" },
  { id: 11, name: "Coursework" },
  { id: 12, name: "Creative Writing" },
  { id: 13, name: "Article Review" },
  { id: 14, name: "Descriptive Essay" },
  { id: 15, name: "Discussion Post" },
  { id: 16, name: "Dissertation" },
  { id: 17, name: "Essay (Any type)" },
  { id: 18, name: "Expository Essay" },
  { id: 19, name: "Infographic" },
  { id: 20, name: "Lab Report" },
  { id: 21, name: "Literary Analysis" },
  { id: 22, name: "Literature Review" },
  { id: 23, name: "Memo (Memorandum)" },
  { id: 24, name: "Narrative Essay" },
  { id: 25, name: "Persuasive Essay" },
  { id: 26, name: "Policy Paper" },
  { id: 27, name: "Powerpoint" },
  { id: 28, name: "Press Release" },
  { id: 29, name: "Question-Answer" },
  { id: 30, name: "Reflection Paper" },
  { id: 31, name: "Report (General)" },
  { id: 32, name: "Research Paper" },
  { id: 33, name: "Research Proposal" },
  { id: 34, name: "Response Paper" },
  { id: 35, name: "Speech" },
  { id: 36, name: "Systematic Review" },
  { id: 37, name: "Term Paper" },
  { id: 38, name: "Thesis" },
  { id: 39, name: "Blog Post" },
  { id: 40, name: "Project Proposal" },
  { id: 41, name: "Grant Proposal" },
  { id: 42, name: "Personal Statement" },
  { id: 43, name: "Statement of Purpose" },
  { id: 44, name: "Cover Letter" },
  { id: 45, name: "Resume/CV" },
  { id: 46, name: "Executive Brief" },
  { id: 47, name: "White Paper" },
  { id: 48, name: "Position Paper" },
  { id: 49, name: "Debate Speech" },
  { id: 50, name: "Presentation Script" },
  { id: 51, name: "Poster Presentation" },
  { id: 52, name: "Marketing Plan" },
  { id: 53, name: "SWOT Analysis" },
  { id: 54, name: "Reflective Journal" },
  { id: 55, name: "Learning Journal" },
  { id: 56, name: "Research Summary" },
  { id: 57, name: "Article Summary" },
  { id: 58, name: "Book Report" },
  { id: 59, name: "Capstone Project" },
  { id: 60, name: "Nursing Care Plan" },
  { id: 61, name: "SOAP Note" },
  { id: 62, name: "Annotated Outline" },
  { id: 63, name: "Movie Review" },
  { id: 64, name: "Admission Essay" }
]


export const ACADEMIC_LEVELS = [
    { id: 1, name: "College" },
    { id: 2, name: "University" },
    { id: 3, name: "Masters" },
    { id: 4, name: "Doctorate" },
]

export const TYPE_OF_ENGLISH = [
    { id: 1, name: "US English" },
    { id: 2, name: "UK English", extraAdder: "(+10%)" },
    { id: 3, name: "Australia English", extraAdder: "(+10%)" },
]

export const DEADLINES = [
    { id: 1, name: "21 days" },
    { id: 2, name: "14 days" },
    { id: 3, name: "10 days" },
    { id: 4, name: "06 days" },
    { id: 5, name: "04 days" },
    { id: 6, name: "02 days" },
    { id: 7, name: "24 hours" },
    { id: 8, name: "12 hours" },
    { id: 9, name: "06 hours" },
    { id: 10, name: "03 hours" },
]


export const SPACINGS = [
    { id: 1, name: "Double Spacing" },
    { id: 2, name: "Single Spacing" },
    { id: 3, name: "1.5 Spacing" },
]

export const REERENCE_STYLES = [
    { id: 1, name: "MLA" },
    { id: 2, name: "APA" },
    { id: 3, name: "Chicago" },
    { id: 4, name: "Harvard" },
    { id: 5, name: "Turabian" },
    { id: 6, name: "Writer's Choice" },
    { id: 7, name: "Not Applicable" },
]

export const SUBJECTS = {
  "Accounting": [
    "Accounting",
    "Auditing",
    "Cost Accounting",
    "Financial accounting",
    "Managerial accounting",
    "Taxation",
  ],
  "Arts and Humanities": [
    "Architecture",
    "Arts and Humanities",
    "Communications",
    "Creative Arts",
    "English",
    "Linguistics",
    "Literature",
    "Marketing",
    "Media Studies",
    "Philosophy",
    "Public Relations",
  ],
  "Biology": [
    "Anatomy",
    "Biochemistry",
    "Biology",
    "Botany",
    "Cell biology",
    "Ecology",
    "Environmental Science",
    "Genetics",
    "Marine Biology",
    "Microbiology",
    "Nutrition",
    "Pharmacology",
    "Physiology",
    "Zoology",
  ],
  "Biostatistics": "Biostatistics",
  "Business": [
    "Business",
    "Business Analytics",
    "Business Ethics",
    "Business Law",
    "Corporate Finance",
    "Data Analytics",
    "Entrepreneurship",
    "International Business",
    "Organizational Behavior",
    "Risk Management",
  ],
  "Chemistry": [
    "Chemistry",
    "Inorganic chemistry",
    "Organic chemistry",
    "Physical Chemistry",
  ],
  "Computer Science": [
    "Artificial Intelligence",
    "Computer Science",
    "Cybersecurity",
    "Data Science",
    "Database Management",
    "Information Technology",
    "Machine Learning",
    "Software Engineering",
    "Statistics",
  ],
  "Economics": [
    "Econometrics",
    "Economics",
    "Macroeconomics",
    "Microeconomics",
  ],
  "Education": [
    "Curriculum Studies",
    "Early Childhood Education",
    "Education",
    "Special Education",
  ],
  "Engineering": [
    "Biomedical Engineering",
    "Civil Engineering",
    "Computer Engineering",
    "Construction",
    "Electrical Engineering",
    "Engineering",
    "Environmental Engineering",
    "Mechanical Engineering",
  ],
  "Finance": [
    "Corporate Finance",
    "Finance",
    "Investment Analysis",
  ],
  "Health Sciences and Nursing": [
    "Clinical Psychology",
    "Developmental Psychology",
    "Epidemiology",
    "Health Sciences and Nursing",
    "Health Policy and Law",
    "Healthcare",
    "Medicine and Surgery",
    "Mental Health",
    "Nursing",
    "Pharmacy",
    "Public Health",
  ],
  "History": [
    "History",
    "US history",
    "World History",
  ],
  "Law": [
    "Business Law",
    "Constitutional Law",
    "Criminal Justice",
    "Criminal Law",
    "Criminology",
    "Law",
  ],
  "Management": [
    "Human Resource Management",
    "Management",
    "Operations Management",
    "Project Management",
    "Quality and Performance Management",
    "Supply Chain Management",
  ],
  "Mathematics": [
    "Algebra",
    "Applied Mathematics",
    "Calculus",
    "Mathematics",
  ],
  "Physics": [
    "Astronomy",
    "Physics",
  ],
  "Religion": "Religion",
  "Social Sciences": [
    "Anthropology",
    "Aviation",
    "Geography",
    "Geology",
    "Hospitality and Tourism",
    "International Relations",
    "Political Science",
    "Property/Real Estate",
    "Public Administration",
    "Psychology",
    "Social Sciences",
    "Social Work",
    "Social psychology",
    "Sociology",
  ],
  "Journalism": "Journalism"
};


let arr = [];

for(const [key, value] of Object.entries(SUBJECTS)){
    if(Array.isArray(value)){
        arr = arr.concat(value)
    }else{
        arr.push(value)
    }
}

arr.sort()
arr.push("Other Subject")

// exports.subjects = subjects;

export const SUBJECTS_ARRAY = new Array(...new Set(arr)).map((it, index) => {return {id: (index + 1), name: it}});
